import { c as _c } from "react/compiler-runtime";
import { varAlpha } from 'minimal-shared/utils';
import { ratingClasses } from '@mui/material/Rating';
import SvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';

// ----------------------------------------------------------------------

const RatingIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M17.56 21a1 1 0 0 1-.46-.11L12 18.22l-5.1 2.67a1 1 0 0 1-1.45-1.06l1-5.63-4.12-4a1 1 0 0 1-.25-1 1 1 0 0 1 .81-.68l5.7-.83 2.51-5.13a1 1 0 0 1 1.8 0l2.54 5.12 5.7.83a1 1 0 0 1 .81.68 1 1 0 0 1-.25 1l-4.12 4 1 5.63a1 1 0 0 1-.4 1 1 1 0 0 1-.62.18" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const MuiRating = {
  /** DEFAULT PROPS */
  defaultProps: {
    emptyIcon: <RatingIcon />,
    icon: <RatingIcon />
  },
  /** STYLE */
  styleOverrides: {
    root: {
      [`&.${ratingClasses.disabled}`]: {
        opacity: 0.48
      }
    },
    iconEmpty: ({
      theme
    }) => ({
      color: varAlpha(theme.vars.palette.grey['500Channel'], 0.48)
    }),
    sizeSmall: {
      [`& .${svgIconClasses.root}`]: {
        width: 20,
        height: 20
      }
    },
    sizeMedium: {
      [`& .${svgIconClasses.root}`]: {
        width: 24,
        height: 24
      }
    },
    sizeLarge: {
      [`& .${svgIconClasses.root}`]: {
        width: 28,
        height: 28
      }
    }
  }
};
export const rating = {
  MuiRating
};